import { render } from "./JoinSecond.vue?vue&type=template&id=277825ac&scoped=true"
import script from "./JoinSecond.vue?vue&type=script&lang=js"
export * from "./JoinSecond.vue?vue&type=script&lang=js"

import "./JoinSecond.vue?vue&type=style&index=0&id=277825ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277825ac"]])

export default __exports__